import "../scss/column_control.scss"